import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=9c1582e6&scoped=true&"
import script from "./reward.vue?vue&type=script&lang=js&"
export * from "./reward.vue?vue&type=script&lang=js&"
import style0 from "./reward.vue?vue&type=style&index=0&id=9c1582e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1582e6",
  null
  
)

export default component.exports